export { default } from './InputBox';


// WEBPACK FOOTER //
// ./src/components/shared/InputBox/index.ts